export default __webpack_public_path__ + "static/media/envio-hover.fbb81f90.svg";